export var uniqueArrayBy = function uniqueArrayBy(inputArray, uniqueKey) {
  var unique = [];
  var seen = {};
  inputArray.map(function (item) {
    if (!seen[item[uniqueKey]]) {
      seen[item[uniqueKey]] = item;
      unique.push(item);
    }
  });
  return unique;
};
export var orderArrayBy = function orderArrayBy(inputArray, key) {
  if (!inputArray || inputArray.lenghth === 0) {
    return inputArray;
  }

  return inputArray.sort(function (a, b) {
    return a[key] - b[key];
  });
};